import axios from 'axios'

export default {
  login(data) {
    return axios.post('/login', data).then(response => {
      return { success: true, user: response.data }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  },
  get() {
    return axios.get('/profile').then(response => {
      return { success: true, user: response.data }
    }, response => {
      throw { success: false, errors: response.errors }
    })
  }
}
